import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = 'https://tribaltech-backend.onrender.com';

export default function VaultVerify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [err, setErr] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (!token) { setErr('Missing token'); return; }
    axios.get(`${API}/api/vault/verify`, { params: { token } })
      .then(r => {
        localStorage.setItem('vault_token', r.data.jwt);
        localStorage.setItem('vault_email', r.data.email);
        navigate('/vault/my-purchases', { replace: true });
      })
      .catch(e => setErr(e.response?.data?.error || e.message));
  }, [params, navigate]);

  return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(180deg, #0f0f1e 0%, #0a0a0f 100%)',
                  display:'flex', alignItems:'center', justifyContent:'center', padding:'40px 20px' }}>
      <div style={{ background:'#111', borderRadius: 16, padding: 32, maxWidth: 480, width:'100%',
                    border:'1px solid #222', textAlign:'center' }}>
        {err ? (
          <>
            <h1 style={{ color:'#f87171', fontSize: 22, marginBottom: 10 }}>Can't sign you in</h1>
            <p style={{ color:'#94a3b8' }}>{err}</p>
            <p style={{ color:'#94a3b8', marginTop: 20, fontSize: 13 }}>
              <a href="/vault/login" style={{ color:'#a78bfa' }}>Request a new link</a>
            </p>
          </>
        ) : (
          <div style={{ color:'#888' }}>Signing you in…</div>
        )}
      </div>
    </div>
  );
}
